<template>
<w-setting-sliding-popup ref="slidingPopup" width="600px" :title="titleName" @close="onClose">
  <div slot="content">
    <el-row type="flex" justify="start" align="middle" style="height: 40px; margin-bottom: 8px;">
      <el-row tyle="flex" class="mr-r10">
        템플릿 종류
      </el-row>
      <el-select :disabled="popupType === 'EDIT'" v-model="targetTmplType" size="small" @change="onChangeTmplType">
        <el-option v-for="item in tmplTargetTypeList" :key="item.templateTargetType" :label="item.templateTargetTypeName" :value="item.templateTargetType"></el-option>
      </el-select>
    </el-row>
    <div class="title-bar title-h4 mr-t30">벤더 및 모델 정보</div>
    <el-form :model="vendorModelInfo" label-position="top" class="mr-b25" ref="vendorModelName">
      <el-row :gutter="20">
        <el-col :span="12">
          <!-- 벤더 유효성 검사 -->
          <el-form-item label="벤더사 명" prop="objCompanyName" :rules="{ trigger: 'blur', validator: this.validateModel }">
            <el-input :disabled="true" v-model="objCompanyName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="벤더사 OID" prop="objCompanyOid">
            <el-input :disabled="true" v-model="objCompanyOid"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 추가 팝업의 경우 multi select 제공 -->
      <el-row :gutter="20" v-if="templateModelShowFlag && popupType ==='ADD'">
        <el-col :span="24">
          <el-form-item label="모델명" prop="objProductId" :rules="{ trigger: 'blur', validator: this.validateModel }">
            <el-select multiple :disabled="popupType === 'EDIT'" v-model="selectObjProductId" style="width:100%" @change="selectProductChange">
              <el-option v-for="item in productInfoList" :key="`${item.objCompanyId}${item.objProductId}`" :label="item.objProductId" :value="item.objProductId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 수정 팝업일 경우 기본 select 제공 -->
      <el-row :gutter="20" v-else-if="templateModelShowFlag && popupType ==='EDIT'">
        <el-col :span="12">
          <el-form-item label="모델명" prop="objProductId" :rules="{ trigger: 'blur', validator: this.validateModel }">
            <el-select :disabled="popupType === 'EDIT'" v-model="selectObjProductId" style="width:100%" filterable :allow-create="false" @change="selectProductChange">
              <el-option v-for="item in productInfoList" :key="`${item.objCompanyId}${item.objProductId}`" :label="item.objProductId" :value="item.objProductId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="모델 OID" prop="objOid">
            <el-input :disabled="true" v-model="vendorModelInfo.objOid"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 장비 템플릿 -->
    <div v-show="templateObjShowFlag" class="mr-t20">
      <el-row type="flex" class="title-bar mr-b10" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4">장비목록</div>
          <div class="setting-addel mr-l15">
            <el-button size="mini" icon="fas fa-check-square" :disabled="popupType === 'EDIT'" @click="checkAllList(true)"></el-button>
            <el-button size="mini" icon="fas fa-square" :disabled="popupType === 'EDIT'" @click="checkAllList(false)"></el-button>
          </div>
        </div>
        <div>
          <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
        </div>
      </el-row>
      <el-table-wrapper class="mr-r10" ref="venderDeviceTableRef" style="height: 300px;" fit-height border :data="venderDeviceTableData" :columns="venderDeviceColumns" :pagination="true"
        remote @condition-change="getVenderDeviceForTemplate" :column-default="columnDefault" :total="total" :show-custom-header="true" :show-search-tool="showSearchTool">
        <template slot-scope="scope" slot="checkFlag">
            <el-checkbox v-model="scope.row.checkFlag" :disabled="popupType === 'EDIT'" :true-label="1" :false-label="0"></el-checkbox>
        </template>
      </el-table-wrapper>
    </div>
    <hr class="mr-b15 mr-t15" />
    <!-- 성능 OID 추가 컴포넌트 -->
    <div class="title-h4 mr-b15">성능 OID 추가</div>
    <el-form ref="oidForm" :model="perfOidInfo" label-position="top" >
      <el-row v-for="item in rscIdList" :key="item.templatetypeRscId" :gutter="20" style="margin-left: 0px; margin-right: 0px;">
        <el-row type="flex" justify="space-between">
          <div>{{item.templatetypeRscName}}
            <!-- oid 입력 길이가 한계치를 넘어갈 경우 경고 스타일 적용, 여러개의 input 데이터를 하나의 문자열로 서비스에서 합쳐 DB저장하는 구조이므로 쉼표도 계산에 포함되도록 하였음 -->
            <span :class="verseCountConvert(perfOidInfo[item.templatetypeRscId]) + (perfOidInfo[item.templatetypeRscId] ? perfOidInfo[item.templatetypeRscId].length-1 : 0) > verseCountLimit ? 'oid-verse-limit-count' : ''">
              {{` (${verseCountConvert(perfOidInfo[item.templatetypeRscId]) + (perfOidInfo[item.templatetypeRscId] ? perfOidInfo[item.templatetypeRscId].length-1 : 0)}/${verseCountLimit})`}}
            </span>
          </div>
        </el-row>
        <el-form-item>
          <el-row v-for="(targetPerf, index) in perfOidInfo[item.templatetypeRscId]" :key="index" type="flex" :gutter="10" class="mr-b5">
            <el-col :span="17">
              <el-input v-model="targetPerf.oid" placeholder="입력해 주세요."></el-input>
            </el-col>
            <el-col v-if="index < 1 && targetPerf.snmpRequestType === 'GET'" :span="2" style="display: flex; justify-content: center;">
              <el-button size="small" type="plain" @click="onClickOidBtn(item.templatetypeRscId, 'add', index)">
                <i class="fas fa-plus" />
              </el-button>
            </el-col>
            <el-col v-if="index > 0" :span="2" style="display: flex; justify-content: center;">
              <el-button size="small" type="plain" @click="onClickOidBtn(item.templatetypeRscId, 'delete', index)">
                <i class="fas fa-minus" />
              </el-button>
            </el-col>
            <el-col :span="targetPerf.snmpRequestType === 'GET' ? 5 : 7">
              <el-select v-if="index < 1" v-model="targetPerf.snmpRequestType" @change="onChangeOidPerfSelect(item.templatetypeRscId, ...arguments)">
                <el-option label="GET" value="GET"></el-option>
                <el-option label="SUBTREE" value="SUBTREE"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" type="solid" class="mr-r4" @click="savePerfOidList">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-setting-sliding-popup>
</template>

<script>
import { find, clone, isNil, isEmpty, forEach, cloneDeep, isUndefined } from 'lodash';
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import { columnDefault } from '@/constants/table';
import { isTrue } from '@/utils/boolean';

export default {
  name: 'WPerfOidPopup',
  props: {
    editRow: Object,
    isAdd: Boolean,
    popupType: String,
    selectVendor: Object,
    tmplTargetTypeList: Array,
    rscIdList: Array,
  },
  data() {
    return {
      columnDefault,
      verseCountLimit: 1000, // 문자 제한 개수 - 해당 컬럼 varchar = 1000으로 설정하기로 협의
      targetTmplType: '',
      selectObjProductId: [],
      productInfoList: [],
      vendorModelName: 'vendorModelName',
      titleName: '',
      objCompanyOid: null,
      objCompanyName: null,
      vendorModelInfo: {
        objCompanyId: null,
        objProductId: null,
        objOid: null,
        objtypeId: null,
        objCompanyName: null,
        objOids: [],
        objProductIds: [],
      },
      perfOidInfo: [],
      templatetypeKey: 'DEVICE_PERF',
      venderDeviceTableData: [],
      showSearchTool: false,
      total: null,
      venderDeviceColumns: [
        {
          width: 90,
          scopedSlot: 'checkFlag',
          label: '선택',
        },
        {
          prop: 'objName',
          label: '장비 명',
          remoteProp: 'o.obj_name',
          sortable: true,
          searchable: true,
        },
        {
          prop: 'ipaddress',
          label: 'IP 주소',
          remoteProp: 'ipaddress',
          sortable: true,
          searchable: true,
        },
      ],
      targetCopyTmpl: {}, // 복제 템플릿 대상 정보
    };
  },
  computed: {
    templateModelShowFlag() {
      return this.targetTmplType === 'TARGET_OBJ_OID';
    },
    templateObjShowFlag() {
      return this.targetTmplType === 'TARGET_OBJ';
    },
  },
  watch: {
    /**
     * 19. 09. 23 수정 - SKCC 성능 자원 추가에 따라 동적으로 성능자원 불러와 바인딩하도록 수정 [SKT - Song]
     * 19. 12. 02 수정 - 템플릿 복제 기능 추가 [SKT - Song]
     * 19. 01. 08 수정 - 모델 템플릿 다중 선택 기능 추가 [SKT - Song]
     * 20. 01. 22 수정 - 성능 OID 입력 시 유효성 추가 [SKT - Song]
     *
     * @return {[type]} [description]
     * @author yelim - Song
     */
    editRow: {
      handler(row) {
        this.perfOidInfo = clone(row);
        if (this.popupType === 'ADD') {
          // 초기세팅
          forEach(this.rscIdList, (item, index) => {
            let targetOid = '';
            let targetSnmpType = 'GET';
            // 데이터가 있을 경우 복제기능을 통한 추가에 해당한다.
            if (!isUndefined(this.targetCopyTmpl)) {
              targetOid = this.targetCopyTmpl[index].templateRscOid;
              targetSnmpType = this.targetCopyTmpl[index].snmpRequestType;
            }
            this.$set(this.perfOidInfo, item.templatetypeRscId, [{ oid: targetOid, snmpRequestType: targetSnmpType }]);
          });
          // templateOid 포맷
          this.templateOidFormatter(this.perfOidInfo);
          this.titleName = '성능 OID 정보 추가';
          this.targetTmplType = 'TARGET_VENDER_ID';
        } else if (this.popupType === 'EDIT') {
          // 값 세팅
          this.vendorModelInfo = {
            objCompanyId: this.selectVendor.objCompanyId,
            objProductId: row.dictInfo,
            objOid: row.templateTarget,
            objtypeId: null,
            objCompanyName: this.selectVendor.objCompanyName,
          };
          this.titleName = '성능 OID 정보 수정';
          this.selectObjProductId = row.dictInfo;
          this.targetTmplType = row.templateTargetType;
          if (isNil(this.selectObjProductId) || this.selectObjProductId === '') {
            this.selectObjProductId = this.editRow.objProductId;
          }
          // templateOid 포맷
          this.templateOidFormatter(this.perfOidInfo);
        }
        this.loadProductList();
        this.getVenderDeviceForTemplate();
      },
      immediate: true,
    },
    selectVendor: {
      handler() {
        if (!isNil(this.selectVendor)) {
          this.objCompanyName = this.selectVendor.objCompanyName;
          this.objCompanyOid = this.selectVendor.objCompanyOid;
        }
      },
      immediate: true,
    },
    /**
     * 유효성 검사 - TARGET_OBJ_OID 모델
     * @return {[type]} [description]
     * @author  Song
     */
    selectObjProductId(value) {
      if (isEmpty(value)) {
        const form = this.$refs[this.vendorModelName];
        if (!isEmpty(form)) {
          form.validateField('objProductId');
        }
        return;
      }
      this.$nextTick(() => {
        const form = this.$refs[this.vendorModelName];
        if (!isEmpty(form)) {
          form.validateField('objProductId');
        }
      });
    },
  },
  methods: {
    onClose() {
      this.$refs[this.vendorModelName].resetFields();
      this.$refs[this.vendorModelName].clearValidate();
      this.selectObjProductId = this.popupType === 'EDIT' ? '' : []; // select, multi select의 v-model 값 타입 차이에 따라 에러 발생하여 초기화 처리
      this.vendorModelInfo.objOid = null;
      this.vendorModelInfo.objOids = [];
      this.vendorModelInfo.objProductIds = [];
    },
    closePopup() {
      this.$refs.slidingPopup.close();
    },
    open(targetCopyTmpl) {
      this.targetCopyTmpl = targetCopyTmpl;
      this.$refs.slidingPopup.open();
    },
    /**
     * 장비 모델 조회, 추가 팝업창의 경우만 모델 수정
     * @return {[type]} [description]
     * @author Song
     */
    loadProductList() {
      if (!isNil(this.selectVendor) && (this.popupType === 'ADD')) {
        NetdeviceSettingAPI.getObjProductList({ objCompanyId: this.selectVendor.objCompanyId }).then((result) => {
          if (result.data.success) {
            this.productInfoList = result.data.data;
            this.selectObjProductId = result.data.data.length > 0 ? result.data.data[0] : null;
          }
        });
      }
    },
    /**
     * 모델 변경 시 해당 모델 템플릿이 존재하는 지 확인 및 모델 OID값을 매핑한다.
     * @return {[type]} [description]
     * @author Song
     */
    selectProductChange(value) {
      const tempOid = [];
      forEach(value, (target) => {
        const targetRow = find(this.productInfoList, (item) => (item.objProductId === target));
        tempOid.push(targetRow.objOid);
      });
      Object.assign(this.vendorModelInfo, { objOids: tempOid, objProductIds: value });
    },
    /**
     * [getTemplateInfo 입력된 값에 따라 템플릿 아이디와 이름을 설정한다.]
     * 19. 09. 06 장비템플릿 추가
     * @author yelim - Song
     */
    getTemplateInfo(count) {
      const vendorModelInfo = this.vendorModelInfo;
      let tmplName;
      let tmplId;
      let tmplType;
      let templatetypeId;
      if (this.popupType === 'ADD') {
        templatetypeId = 'DEVICE_PERF';
        if (this.targetTmplType === 'TARGET_VENDER_ID') {
          // 벤더 템플릿
          tmplType = 'TARGET_VENDER_ID';
          tmplId = `DEVICE_PERF.${this.selectVendor.objCompanyId}`;
          tmplName = `${this.objCompanyName} 템플릿`;
        } else if (this.targetTmplType === 'TARGET_OBJ_OID') {
          // 모델 템플릿
          if (!isUndefined(count)) {
            tmplType = 'TARGET_OBJ_OID';
            tmplId = `DEVICE_PERF.${this.selectVendor.objCompanyId}.${vendorModelInfo.objProductIds[count]}`;
            tmplName = `${this.objCompanyName} ${vendorModelInfo.objProductIds[count]} 템플릿`;
          } else {
            tmplType = 'TARGET_OBJ_OID';
            tmplId = `DEVICE_PERF.${this.selectVendor.objCompanyId}.${vendorModelInfo.objProductId}`;
            tmplName = `${this.objCompanyName} ${vendorModelInfo.objProductId} 템플릿`;
          }
        } else {
          // 장비
          tmplType = 'TARGET_OBJ';
          tmplId = `DEVICE_PERF.${this.selectVendor.objCompanyId}.TARGET_OBJ`; // objIds를 대상으로 서비스단에서 재가공할 것임
          tmplName = `${this.objCompanyName} 장비 템플릿`;
        }
      } else {
        templatetypeId = this.editRow.templatetypeId;
        tmplId = this.editRow.templateId;
        tmplName = this.editRow.taemplateName;
      }
      return { tmplType, tmplId, tmplName, templatetypeId };
    },
    /**
     * [savePerfOidList] 입력한 oid에 대한 저장을 일괄 수행한다.
     * 1. 유효성 검사: 템플릿, 모델 등 선택에 대한 유효성 검사
     * 2. 유효성 검사: 각 자원별 oid 길이제한에 대한 유효성 검사
     * @author Song
     */
    savePerfOidList() {
      this.$refs[this.vendorModelName].validate((valid) => {
        if (valid) {
          // oid 입력 유효성 체크
          const oidValidateCheck = this.$refs.oidForm.$el.querySelector('.oid-verse-limit-count');
          if (!isNil(oidValidateCheck)) {
            this.$message(msgUtil.getCustomMsgData('입력가능한 Oid 길이를 초과하였습니다.'));
            return;
          }
          let templateInfo = {};
          const templateParam = [];
          // 모델 템플릿이면서 추가의 경우만 모델 다중 선택이 가능하다.
          if (this.targetTmplType === 'TARGET_OBJ_OID' && this.popupType === 'ADD') {
            for (let i = 0; i < this.vendorModelInfo.objOids.length; i += 1) {
              const tempList = this.getTemplateInfo(i);
              templateParam.push({
                templatetypeId: tempList.templatetypeId,
                templateId: tempList.tmplId,
                templateName: tempList.tmplName,
              });
            }
          } else {
            // 수정의 경우는 OID 값만 수정이 되므로 아래와 같은 처리를 한다.
            templateInfo = this.getTemplateInfo();
            templateParam.push({
              templatetypeId: templateInfo.templatetypeId,
              templateId: templateInfo.tmplId,
              templateName: templateInfo.tmplName,
            });
          }
          if (this.popupType === 'ADD') {
            this.insertPerfOid(templateParam, this.targetTmplType);
          } else {
            this.updatePerfOid(templateParam);
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('정보를 올바르게 입력해주십시오.'));
        }
      });
    },
    /**
     * 성능 OID를 추가한다.
     * 19. 9. 5 - snmpRequestType 컬럼 추가에 따른 방식 변경 및 모듈관련 자원도 추가, 데이터 구조 변경 (SKCC)
     * 19. 01. 08 수정 - 모델 템플릿 다중 선택 기능 추가 [SKT - Song]
     *
     * @author Ju - Song
     * @param  {Object} templateParam NmsRsctypeTmpl 객체
     */
    insertPerfOid(templateParam, tmplType) {
      const objIds = this.getSelectedObjids(); // 장비템플릿 > 선택한 장비를 가져온다.
      const resultParams = [];
      if (this.targetTmplType === 'TARGET_OBJ' && objIds.length < 1) {
        this.$message(msgUtil.getCustomMsgData('장비를 하나 이상 선택해주세요.'));
        return;
      }
      // 작성된 템플릿 갯수만큼 반복하도록 한다.
      forEach(templateParam, (templateInfo, templateIndex) => {
        // nms_rsctype_tmpl
        const templateId = templateInfo.templateId;
        const templatetypeId = templateInfo.templatetypeId;

        // nms_rsc_tmpl
        const nmsRscTmpl = {
          templateId,
          templatetypeId,
          templatetypeKey: this.templatetypeKey,
        };
        const nmsRscTmplList = [];
        forEach(this.rscIdList, (item) => {
          // 수집방식 (get, subtree) 컬럼 추가에 따라 templatetypeRscOid 값이 복수일 경우 쉼표단위로 합쳐서 보낼 것
          let templatetypeRscOid = '';
          // Oid값이 공백이라면 0 값을 넣어주도록한다. get방식의 경우 다중값을 설정할 수 있지만 공백이 아닌 값이 있다면 나머지 공백 값은 생략한다.
          // ex) oid값 모두 공백 => 0으로 세팅, oid값이 공백,3,4 이렇게 있다면 3,4만 저장하도록
          forEach(this.perfOidInfo[item.templatetypeRscId], (rscOid, index) => {
            if (index > 0 && rscOid.oid !== '') {
              if (templatetypeRscOid === '0') {
                templatetypeRscOid = '';
              } else {
                templatetypeRscOid += rscOid.oid === '' ? '' : ',';
              }
            }
            if (rscOid.oid !== '' || index === 0) {
              templatetypeRscOid += rscOid.oid === '' ? 0 : `${rscOid.oid}`;
            }
          });
          nmsRscTmplList.push({
            ...nmsRscTmpl,
            templatetypeRscId: item.templatetypeRscId,
            templatetypeRscOid,
            snmpRequestType: this.perfOidInfo[item.templatetypeRscId][0].snmpRequestType,
          });
        });

        // nms_rsc_tmpl_target_set
        const nmsRscTmplTargetSet = {
          templateId,
          templateTargetType: tmplType,
        };
        if (tmplType === 'TARGET_VENDER_ID') {
          nmsRscTmplTargetSet.templateTarget = this.selectVendor.objCompanyId;
        } else if (tmplType === 'TARGET_OBJ_OID') {
          nmsRscTmplTargetSet.templateTarget = this.vendorModelInfo.objOids[templateIndex];
        } else if (tmplType === 'TARGET_OBJ') {
          nmsRscTmplTargetSet.templateTarget = 'TARGET_OBJ';
        }

        resultParams.push({
          NMS_RSCTYPE_TMPL: JSON.stringify(templateInfo),
          NMS_RSC_TMPL: JSON.stringify(nmsRscTmplList),
          NMS_RSC_TMPL_TARGET_SET: JSON.stringify(nmsRscTmplTargetSet),
          objIds,
          tmplType,
        });
      });

      const target = '성능 OID';
      const action = msgUtil.action.ADD;

      NetdeviceSettingAPI.insertNmsRscTmpl(resultParams).then((result) => {
        if (result.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.closePopup();
          this.$emit('reload-data');
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * 성능 OID를 수정한다.
     * 19. 09. 06 장비 템플릿 개념이 추가되면서 구조적 변경 (template_group_id, objIds)
     * 19. 01. 08 수정 - 모델 템플릿 다중 선택 기능 추가 [SKT - Song]
     *
     * @author Ju - Song
     * @param  {Object} templateParam NmsRsctypeTmpl 객체
     */
    updatePerfOid(templateParam) {
      // nms_rsc_tmpl
      const nmsRscTmpl = {
        templateId: templateParam[0].templateId,
        templatetypeId: templateParam[0].templatetypeId,
        templatetypeKey: this.templatetypeKey,
      };
      const nmsRscTmplList = [];
      forEach(this.rscIdList, (item) => {
        let templatetypeRscOid = '';
        forEach(this.perfOidInfo[item.templatetypeRscId], (rscOid, index) => {
          if (index > 0 && rscOid.oid !== '') {
            if (templatetypeRscOid === '0') {
              templatetypeRscOid = '';
            } else {
              templatetypeRscOid += rscOid.oid === '' ? '' : ',';
            }
          }
          if (rscOid.oid !== '' || index === 0) {
            templatetypeRscOid += rscOid.oid === '' ? 0 : `${rscOid.oid}`;
          }
        });
        nmsRscTmplList.push({
          ...nmsRscTmpl,
          templatetypeRscOid,
          templatetypeRscId: item.templatetypeRscId,
          snmpRequestType: this.perfOidInfo[item.templatetypeRscId][0].snmpRequestType,
          templateGroupId: this.editRow.templateGroupId,
        });
      });
      const target = '성능 OID';
      const action = msgUtil.action.MODIFY;
      NetdeviceSettingAPI.updateNmsRscTmpl(nmsRscTmplList).then((result) => {
        if (result.data.success) {
          this.$message(msgUtil.getResultMsgData(action, target, true));
          this.closePopup();
          this.$emit('reload-data');
        } else {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(action, target, false));
      });
    },
    /**
     * [validateModel 설정된 벤더값/모델 값에 따라 validation을 수행한다.]
     * 구성 OID 템플릿 - 벤더, 모델 존재 유무 검사
     *
     * @author  Song
     */
    validateModel(rule, value, callback) {
      const templateInfo = this.getTemplateInfo();
      let params = {};
      let message;
      if (this.popupType === 'ADD') {
        if (!isNil(templateInfo)) {
          if (templateInfo.tmplType === 'TARGET_VENDER_ID') {
            params = {
              templateTargetType: templateInfo.tmplType,
              templateTarget: this.selectVendor.objCompanyId,
            };
            message = '이미 성능 OID가 설정된 벤더입니다.';
          } else if (templateInfo.tmplType === 'TARGET_OBJ_OID' && rule.field !== 'objCompanyName') {
            params = {
              templateTargetType: templateInfo.tmplType,
              templateTarget: this.vendorModelInfo.objOids,
            };
            message = '이미 성능 OID가 설정된 모델입니다.';
          } else {
            callback();
          }
        }
        if (this.selectObjProductId && this.selectObjProductId.length < 1) {
          callback(new Error('필수 값입니다.'));
        } else {
          // 성능 OID 사전 - 벤더 & 모델 존재 유무 조회
          NetdeviceSettingAPI.getExistPerfVenderModel(params).then((result) => {
            if (result.data.success) {
              const res = result.data.data;
              if (res.count === 0) {
                callback();
              } else if (templateInfo.tmplType === 'TARGET_OBJ_OID') {
                callback(new Error(`${res.objProductId} 모델은 템플릿이 이미 존재합니다.`));
              } else {
                callback(new Error(message));
              }
            }
          });
        }
      } else {
        callback();
      }
    },
    /**
     * [성능 OID 추가/삭제 - key: 자원종류, type: 추가/삭제, index: 삭제 대상]
     * @author Song
     */
    onClickOidBtn(key, type, index) {
      if (type === 'add') {
        this.perfOidInfo[key].push({
          oid: '',
          snmpRequestType: 'GET',
        });
      } else {
        this.perfOidInfo[key].splice(index, 1);
      }
    },
    /**
     * snmpRequestType 변경 - get방식의 경우만 다중 입력 가능
     * SUBTREE로 변경 시 기존 GET방식의 0번째 방만 세팅한다.
     * @author Song
     */
    onChangeOidPerfSelect(key, value) {
      if (value === 'SUBTREE') {
        const after = [];
        const temp = cloneDeep(this.perfOidInfo[key][0].oid);
        after.push({ oid: temp, snmpRequestType: value });
        this.perfOidInfo[key] = after;
      }
    },
    /**
     * 템플릿 종류에 따라 값에 대한 초기화를 실시
     * @author Song
     */
    onChangeTmplType(value) {
      this.selectObjProductId = this.productInfoList.length > 0 ? [this.productInfoList[0].objProductId] : null;
      this.vendorModelInfo.objProductId = this.productInfoList.length > 0 ? this.productInfoList[0].objProductId : null;
      this.vendorModelInfo.objOids = this.productInfoList.length > 0 ? [this.productInfoList[0].objOid] : null;
      this.$refs.vendorModelName.clearValidate();

      if (value !== 'TARGET_OBJ_OID') {
        this.selectObjProductId = [];
        this.vendorModelInfo.objOids = [];
      }
    },
    // all-check/uncheck
    checkAllList(value) {
      if (!isNil(this.venderDeviceTableData) && this.venderDeviceTableData.length > 0) {
        forEach(this.venderDeviceTableData, (item) => {
          item.checkFlag = value;
        });
      }
    },
    /**
     * 벤더에 해당하는 장비 리스트 조회 - 성능 OID
     * @return {[type]} [description]
     * @author Song
     */
    getVenderDeviceForTemplate() {
      if (!isNil(this.selectVendor)) {
        if (this.popupType === 'EDIT' && this.targetTmplType !== 'TARGET_OBJ') {
          return;
        }
        this.$nextTick(() => {
          const tableParams = this.$refs.venderDeviceTableRef.getParameter();
          const params = {
            ...tableParams,
            objCompanyId: this.selectVendor.objCompanyId,
            popupType: this.popupType,
            templateGroupId: this.editRow.templateGroupId,
          };
          NetdeviceSettingAPI.getVenderDeviceForPerfTemplate(params).then((result) => {
            if (result.data.success) {
              this.venderDeviceTableData = result.data.data;
              this.total = result.data.total;
            }
          });
        });
      }
    },
    /**
     * 테이블에서 체크한 row들을 가져온다.
     * @return {[type]} [description]
     * @author Song
     */
    getSelectedObjids() {
      const selectedObjIds = [];
      forEach(this.venderDeviceTableData, (item) => {
        if (isTrue(item.checkFlag)) {
          selectedObjIds.push(item.objId);
        }
      });
      return selectedObjIds;
    },
    /**
     * templateOid 쉼표를 구분하여 포맷
     * @return {[type]} [description]
     * @author Song
     */
    templateOidFormatter(row) {
      forEach(this.rscIdList, (item) => {
        const targetOidArr = row[item.templatetypeRscId][0].oid.split(',');
        const tempArr = [];
        forEach(targetOidArr, (target) => {
          tempArr.push({ oid: target, snmpRequestType: row[item.templatetypeRscId][0].snmpRequestType });
        });
        row[item.templatetypeRscId] = tempArr;
      });
    },
    /**
     * [verseCountValidate] 입력한 배열상태의 oid들을 모두 더하여 길이를 구한다.
     * @return {[type]} [description]
     * @author Song
     */
    verseCountConvert(value) {
      if (value) {
        return value.reduce((acc, cur) => acc + cur.oid.length, 0);
      }
      return 0;
    },
  },
};
</script>

<style>
.oid-verse-limit-count {
  color: #f6576a;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/PerformanceOidSettings/popup/PerfOidPopup.vue